import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  
  // State baru untuk melacak section yang sedang aktif di Homepage
  const [activeSection, setActiveSection] = useState('');

  // Mendeteksi section mana yang sedang aktif saat di-scroll (Hanya di Homepage)
  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname !== '/') return;

      const sections = ['product-section', 'reward-section', 'about-section', 'footer-section'];
      let current = '';

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          // Jika elemen sudah masuk ke area atas layar (dengan sedikit toleransi offset)
          if (rect.top <= window.innerHeight / 3) {
            current = section;
          }
        }
      }
      setActiveSection(current);
    };

    // Tambahkan event listener scroll
    window.addEventListener('scroll', handleScroll);
    
    // Jalankan sekali saat pertama render untuk mengecek posisi awal
    handleScroll();

    // Bersihkan event listener saat komponen dilepas
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  const handleIdClick = (e, targetId) => {
    e.preventDefault();
    setIsOpen(false);
    setActiveSection(targetId); // Set section aktif secara manual saat diklik

    if (location.pathname === '/') {
      const nextSection = document.getElementById(targetId);
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: targetId } });
    }
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    // Membuat layar otomatis scroll ke paling atas saat pindah halaman
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  // Fungsi helper untuk menentukan warna class Navigasi (Aktif / Tidak)
  const getNavClass = (path, sectionId = null) => {
    const baseClass = "block text-sm font-semibold transition-colors";
    let isActive = false;

    if (sectionId) {
      // Logika aktif untuk section di Homepage
      isActive = location.pathname === '/' && activeSection === sectionId;
    } else {
      // Logika aktif untuk halaman terpisah (Membership / FAQ)
      // TAMBAHAN: Jika path adalah faq, kita cek apakah URL mengandung '/v2/faq'
      if (path === '/v2/faq') {
        isActive = location.pathname.includes('/v2/faq'); 
      } else {
        isActive = location.pathname === path;
      }
    }

    // Jika aktif, warnanya orange. Jika tidak, abu-abu dengan hover orange.
    return `${baseClass} ${isActive ? 'text-[#f97316]' : 'text-[#475467] hover:text-[#f97316]'}`;
  };

  return (
    <nav className="fixed top-0 left-0 bg-white shadow-sm w-full border-b border-gray-100" style={{zIndex:100}}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          
          {/* BAGIAN KIRI: Logo & Nama Brand */}
          <Link to="/" onClick={handleLinkClick} className="flex items-center gap-3">
            <img 
              src="https://summarecon-apps-dev-s3.s3.ap-southeast-3.amazonaws.com/stss/logo.png" 
              alt="Logo Satu Summarecon Sukses" 
              className="w-10 h-10 object-contain rounded-xl shadow-sm" 
            />
            <span className="text-base font-semibold text-[#101828] tracking-wide">
              Satu Summarecon Sukses
            </span>
          </Link>

          {/* TOMBOL HAMBURGER (Hanya tampil di Mobile) */}
          <button 
            className="md:hidden text-gray-800 focus:outline-none p-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>

          {/* BAGIAN KANAN: Link Navigasi */}
          <ul className={`${
              isOpen ? 'flex absolute top-full left-0 w-full bg-white shadow-lg py-4 px-6 flex-col gap-y-4 border-t' : 'hidden'
            } md:flex md:static md:w-auto md:bg-transparent md:flex-row md:items-center md:gap-x-8 md:shadow-none md:border-none md:py-0 md:px-0`}
          >
            <li>
              <Link to="/" onClick={(e) => handleIdClick(e, 'product-section')} className={getNavClass('/', 'product-section')}>
                Product
              </Link>
            </li>
            <li>
              <Link to="/" onClick={(e) => handleIdClick(e, 'reward-section')} className={getNavClass('/', 'reward-section')}>
                Reward
              </Link>
            </li>
            <li>
              <Link to="/v2/membership" onClick={handleLinkClick} className={getNavClass('/v2/membership')}>
                Membership
              </Link>
            </li>
            <li>
              <Link to="/" onClick={(e) => handleIdClick(e, 'about-section')} className={getNavClass('/', 'about-section')}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/v2/faq" onClick={handleLinkClick} className={getNavClass('/v2/faq')}>
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/" onClick={(e) => handleIdClick(e, 'footer-section')} className={getNavClass('/', 'footer-section')}>
                Contact Us
              </Link>
            </li>
          </ul>

        </div>
      </div>
    </nav>
  );
}

export default Navbar;